define([
    'domReady', 'promise!wcs.zmetrics'
], function() {

// Name the plugin
    var PLUGIN_IDENTIFIER = 'trackingProductDataService';
// Create the function that will be bound to JQuery
    var vfdpPlugin = function(element, options) {
        this.element = element;
        this.options = options;
    };

// Define the plugin's prototype and defaults
    vfdpPlugin.prototype = {
        defaults: {
        },

        /**
         * Initializes the plugin instance
         * @returns {Object} This plugin instance
         */
        init: function() {
            var self = this;

            console.debug('Initializing ', PLUGIN_IDENTIFIER, 'on', $(self.element));

            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER+'Options');
            self.config = $.extend(
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );
            var $selectedColorSwatch = $('.attr-box.selected > .color-swatch-button-content');
            self.metadata.colorDescription = $selectedColorSwatch.attr('title');
            self.metadata.colorCode = $selectedColorSwatch.attr('data-variation-id');
            // Initialize events
            self.events();

            // Do any DOM manipulation or other setup
            self._build();

            // Allow JQuery-style chaining of the plugin
            return self;
        },

        /**
         * Binds plugin events
         **/
        events: function() {
            var self = this;
            // create event listeners here
        },

        /**
         * Modifies the DOM to support layout requirements
         **/
        _build: function() {
            var self = this;
            zm.trackProductView(self.metadata);

        }
    };

// Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;

// Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function(options) {
        return this.each(function() {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if(!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };

});
